import { alertActions } from "../../alert.action";

import { pageConstants } from "../../../../constants/cms/page/page.constants";
import { pageService } from "../../../../services/cms/page/page.service";
import { history } from "../../../../helpers/history";
import { cmsActions } from "../cms.action";
export const pageActions = {
  attach,
  update,
  get,
  select,
  removePage,
  softUpdate,
  remove,
  addPage,
  deselect,
  updatePageElement,
  restore,
  checkForUpdates,
  getAllPaths,
};

function attach(element) {
  return (dispatch) => {
    dispatch(success(element));
  };
  function success(element) {
    return { type: pageConstants.PAGE_ATTACH, element };
  }
}
function restore() {
  return (dispatch) => {
    dispatch(success());
  };
  function success() {
    return { type: pageConstants.RESTORE_PAGE };
  }
}
function addPage() {
  return (dispatch) => {
    dispatch(success());
  };
  function success() {
    return { type: pageConstants.ADD_VIEW_PAGE };
  }
}
function removePage() {
  return (dispatch) => {
    dispatch(success());
  };
  function success() {
    return { type: pageConstants.REMOVE_VIEW_PAGE };
  }
}
function checkForUpdates(page, allowOverWrite = false) {
  return (dispatch) => {
    dispatch(alertActions.clear());

    /*   if (allowOverWrite) {
            return dispatch(update(page));
          }
      
    
      
          pageService.checkForUpdates(page.pageId, page.updated).then(
            data => {
              if (data.isModified === true) {
                return dispatch(cmsActions.alertNewModifications(data.isModified, 'PAGE'));
              }
              else { */
    return dispatch(update(page));
    /*     }
          },
          error => {
            
            dispatch(alertActions.error(error));
          }
        ); */
  };
}
function updatePageElement(element, id, page) {
  return (dispatch) => {
    if ((element.props && element.props.inherit !== null) || page.inherit == true) {
      dispatch(cmsActions.inheritageAffected(true));
    }
    dispatch(success({ ...element, hasChanged: true }), id);
  };
  function success(element) {
    return { type: pageConstants.UPDATE_PAGE_ELEMENT, element, id };
  }
}
function deselect() {
  return (dispatch) => {
    dispatch(success());
  };
  function success() {
    return { type: pageConstants.DESELECT_PAGE_ELEMENT };
  }
}
function remove(element) {
  return (dispatch) => {
    dispatch(success(element));
  };
  function success(element) {
    return { type: pageConstants.DELETE_PAGE_ELEMENT, element };
  }
}
function select(element) {
  return (dispatch) => {
    dispatch(success(element));
  };
  function success(element) {
    return { type: pageConstants.PAGE_SELECT, element };
  }
}
function softUpdate(page) {
  return (dispatch) => {
    if (page && page.inherit === true) {
      dispatch(cmsActions.inheritageAffected(true));
    }
    dispatch(success(page));
  };
  function success(page) {
    return { type: pageConstants.SOFT_UPDATE_PAGE, page };
  }
}
function update(page) {
  return (dispatch) => {
    dispatch(request());
    dispatch(alertActions.clear());
    const newPage = Object.assign({}, page);
    const pageElements = Array.from(newPage.pageElements);

    newPage.pageElements = pageElements.map((el) => {
      const pageElement = Object.assign({}, el);
      pageElement.data = JSON.stringify(pageElement.data);
      return pageElement;
    });
    newPage.settings = JSON.stringify(newPage.settings);
    newPage.content = JSON.stringify(newPage.pageElements);
    const { pageId, eventId, templateId, name, content, settings, inherit, title, facebookId, googleAnalyticsId, onlyAuthorizedUsers } = newPage;

    pageService
      .update({
        pageId,
        eventId,
        templateId,
        name,
        facebookId,
        content,
        title,
        settings,
        googleAnalyticsId,
        inherit,
        onlyAuthorizedUsers
      })
      .then(
        (p) => {
          dispatch(success(p));
          if (page.pageId != p.pageId) {
            history.push("/cms/page/" + p.pageId);
          }
        },
        (error) => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      );
  };

  function request() {
    return { type: pageConstants.UPDATE_PAGE_REQUEST };
  }
  function success(page) {
    return { type: pageConstants.UPDATE_PAGE_SUCCESS, page };
  }
  function failure(error) {
    return { type: pageConstants.UPDATE_PAGE_FAILURE, error };
  }
}
function get(pageId, viewMode = false) {
  return (dispatch) => {
    dispatch(request());
    dispatch(alertActions.clear());
    pageService.get(pageId, viewMode).then(
      (page) => {
        dispatch(success(page));
      },
      (error) => {
        dispatch(failure(error));
        if (error === "JX_PAGE_NOTALLOWED") {
          history.push("/");
        }
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: pageConstants.GET_PAGE_REQUEST };
  }
  function success(page) {
    return { type: pageConstants.GET_PAGE_SUCCESS, page };
  }
  function failure(error) {
    return { type: pageConstants.GET_PAGE_FAILURE, error };
  }
}

function getAllPaths(eventId) {
  return (dispatch) => {
    dispatch(alertActions.clear());
    pageService.getAllPaths(eventId).then(
      (pages) => {
        dispatch(set(pages));
      },
      (error) => {
        dispatch(alertActions.error(error));
      }
    );
  };
  function set(pages) {
    return { type: pageConstants.GET_ALL_PAGE_PATHS, pages };
  }
}
